import { ImportActionType } from "../const/import-action-type";
import { SubscriptionSource } from "../const/subscription-source";
import { DuplicatesAction } from "../const/duplicates-action";
import { Delimiters } from "../const/delimiters";
import { TagsAction } from "../const/tags-action";
import { ImportFieldType } from "../const/field-type";
import { ImportUploadStatus } from "../const/import-status";

export default () => ({
  fileToUpload: null,
  importType: null,
  importId: null,
  importStatus: ImportUploadStatus.Default,
  uploadProgress: 0,
  delimiter: Delimiters.Comma,
  actionType: ImportActionType.AddNewUsers,
  noOfRows: 0,
  skipFirstLine: false,
  treatNegativeStatusAsUnknown: "1",
  importHistory: [],
  checksum: null,
  fieldMappings: {
    isPreviewLoading: false,
    selectedFields: [],
    availableFields: [
      ImportFieldType.IGNORE,
      ImportFieldType.EMAIL,
      ImportFieldType.FIRST_NAME,
      ImportFieldType.LAST_NAME,
      ImportFieldType.COUNTRY,
      ImportFieldType.CITY,
      ImportFieldType.LANGUAGE,
      ImportFieldType.PHONE,
      ImportFieldType.TAGS,
      ImportFieldType.GENDER,
      ImportFieldType.BIRTH_DATE,
      ImportFieldType.EMAIL_SUBSCRIPTION_STATUS,
      ImportFieldType.SMS_SUBSCRIPTION_STATUS,
      ImportFieldType.EMAIL_SUBSCRIPTION_CONFIRMATION_DATE,
      ImportFieldType.FULL_NAME,
      ImportFieldType.WHATSAPP_SUBSCRIPTION_STATUS,
    ],
    emailSubscribeFields: [
      ImportFieldType.IGNORE,
      ImportFieldType.EMAIL,
      ImportFieldType.EMAIL_SUBSCRIPTION_STATUS,
      ImportFieldType.EMAIL_SUBSCRIPTION_CONFIRMATION_DATE,
      ImportFieldType.TAGS,
    ],
    smsSubscribeFields: [
      ImportFieldType.IGNORE,
      ImportFieldType.EMAIL,
      ImportFieldType.SMS_SUBSCRIPTION_STATUS,
      ImportFieldType.TAGS,
    ],
    tagsFields: [ImportFieldType.IGNORE, ImportFieldType.EMAIL, ImportFieldType.TAGS],
    previewRows: [],
  },
  tags: {
    newTagName: "",
    isLoading: false,
    importTags: [],
    action: TagsAction.Add,
  },
  subscriptions: {
    source: SubscriptionSource.File,
    email: null,
    sms: null,
    whatsapp: null,
  },
  resurrectCustomer: true,
  duplicates: DuplicatesAction.Override,
});
